export default "__VITE_ASSET__NLH0lSFV__"